import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
import moment from 'moment';
export default class Driver extends Component {
  constructor(props) {
    super(props);
    let url = "/api/v1/portal/jobs/driver/" +
        props.data.driver.id +
        (props.viewAllJobs ? "/all-jobs" : "");

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || {
        driver: null
      },
      isLoading: true,
      viewAllJobs: props.viewAllJobs || null,
      jobs: props.jobs || null,
      url: url || null,
      jobIds:[],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }
  componentDidMount() {
    if (this.state.isLoading) {
      return fetch(
        this.state.url,
        {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token,
            "Accept": 'application/json'
          }
        }
      ).then((responseText) => {
        let response = responseText.json();
        
        response.then((driverJson) => {
          this.setState({
            jobs: driverJson.data,
            isLoading: false
          });
          let jobIds = [];
            this.state.jobs.map((job)=>{
                jobIds.push(job.id);
                
            });
            this.setState({jobIds:jobIds});
            
        });
      });
    }
  }
  componentDidUpdate() {
    let pickupTime = ['?','anytime','am','asap','pm'];
    let scheduledPickupTime = '';
    let scheduledPickupDate = '';
    let msg = null;
    if(this.state.jobs && this.state.jobs.length > 0){
      let tempJob = this.state.jobs[0];
      
      if(pickupTime.indexOf(tempJob.scheduled_pickup_time) != -1){
        //console.log('this.state.jobs',pickupTime.indexOf(tempJob.scheduled_pickup_time) + '= '+tempJob.scheduled_pickup_time + '= '+moment().format("HHmm a"));
        scheduledPickupTime = '0805';
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }else{
        //console.log('else',tempJob.scheduled_pickup_time);
        scheduledPickupTime = tempJob.scheduled_pickup_time;
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }
      /* check if appraisal is not set yet */
      if(tempJob.appraisal_id == null){
        let currentDate = moment().format('YYYY-MM-DD'); 
        if( (moment(currentDate).isSame(scheduledPickupDate)) && (moment().format("HHmm") > scheduledPickupTime)){
          msg = '<div><b>'+this.state.data.full_name+':</b> '+this.state.data.driver.contact_number+'</div>';
          $('#jobs-table-row-'+tempJob.id).addClass('late-driver-alert');
          this.props.saveLateJobIdsOFDriver(tempJob.id);
        }
      }
    }
    //this.props.handleLateDrivers(msg,this.state.data.id);
  }
  render() {
    return(
    <div className="driver-table">
      {
        this.state.isLoading ?
        <div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div> :

          ((  this.state.data &&
              this.state.data.driver &&
              this.state.data.driver.contact_number
            ) ?

              <div className="driver-container">
                <div className="driver-main-info">
                  <div className="row">
                    <div className="col-md-1">
                      <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      />
                    </div>
                    <div className="col-md-3">
                      <strong>Driver Name:</strong> {
                      this.state.data.first_name} {
                      this.state.data.last_name}&nbsp;&nbsp;
                      <a
                        href={"/drivers/view/" + this.state.data.id +
                        "/all-jobs"}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="fa fa-car-side"></i> All Jobs
                      </a>
                    </div>
                    <div className="col-md-1">
                      <strong>Trade Plate:</strong>
                    </div>
                    <div className="col-md-1">
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                    </div>
                    <div className="col-md-2">
                      <i className="fa fa-envelope"></i> {
                      this.state.data.email}
                    </div>
                    <div className="col-md-2">
                      <i className="fa fa-home"></i> {
                      this.state.data.driver.home_address.town_city} {
                      this.state.data.driver.home_address.county_area}
                    </div>
                    <div className="col-md-2">
                      <strong>Active/Working:&nbsp;&nbsp;
                        <button className="btn btn-primary">
                          <b>{(this.state.data.driver.active_status) ? 'YES' : 'NO'}</b>
                        </button>
                      </strong>
                    </div>
                  </div>
                </div>
                <JobsTable
                  url={this.state.url}
                  jobs={this.state.jobs}
                  noCategoryLabels={true}
                  message_if_none='No Jobs found. Add one to see it here.'
                  driverScreen={(this.state.url.search('all-jobs') > -1) ? false : true}
                  jobIds={this.state.jobIds}
                />
              </div>
              : ''
          )
        }
      </div>
    );
  }
}
